import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./assets/style/main.scss"
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import { store } from './store'
import { Provider } from 'react-redux'
import { WagmiConfig, createConfig, createStorage, configureChains } from 'wagmi'
import { sepolia } from 'wagmi/chains'
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'

// 辅助函数：清理环境变量值（去除注释和空格）
const cleanEnvValue = (value) => {
    if (!value) return value;
    // 去除注释（# 及其后面的内容）
    const cleaned = String(value).split('#')[0].trim();
    return cleaned;
}

// L1 链配置 - 从环境变量读取，使用自定义 RPC URL
export const L1_CHAIN = {
    ...sepolia,
    rpcUrls: {
        default: {
            http: [String(process.env.REACT_APP_L1_RPC_URL || sepolia.rpcUrls.default.http[0])]
        },
        public: {
            http: [String(process.env.REACT_APP_L1_RPC_URL || sepolia.rpcUrls.public.http[0])]
        }
    }
}

// L2 链配置 - 从环境变量读取，支持自定义 L2 链
export const L2_CHAIN = {
    id: Number(cleanEnvValue(process.env.REACT_APP_L2_CHAIN_ID)) || undefined,
    name: cleanEnvValue(process.env.REACT_APP_L2_NETWORK_NAME) || "Custom L2",
    network: cleanEnvValue(process.env.REACT_APP_L2_NETWORK_NAME)?.replace(/\s+/g, '_').toUpperCase() || "CUSTOM_L2",
    iconUrl: cleanEnvValue(process.env.REACT_APP_L2_ICON_URL) || "https://i.imgur.com/Q3oIdip.png",
    iconBackground: "#000000",
    nativeCurrency: {
        decimals: 18,
        name: cleanEnvValue(process.env.REACT_APP_L2_NATIVE_CURRENCY_NAME) || 'ETHEREUM',
        symbol: cleanEnvValue(process.env.REACT_APP_L2_NATIVE_CURRENCY_SYMBOL) || 'ETH'
    },
    rpcUrls: {
        default: {
            http: [String(cleanEnvValue(process.env.REACT_APP_L2_RPC_URL) || '')]
        },
    },
    blockExplorers: {
        default: {
            name: `${cleanEnvValue(process.env.REACT_APP_L2_NETWORK_NAME) || "Custom L2"} Explorer`,
            url: cleanEnvValue(process.env.REACT_APP_L2_EXPLORER_URL)
        }
    },
    testnet: true
}

const { chains, publicClient } = configureChains(
    [L1_CHAIN, L2_CHAIN],
    [
        jsonRpcProvider({
            rpc: chain => ({ http: chain.rpcUrls.default.http[0] })

        })
    ])

export const connectors = [
    new MetaMaskConnector({
        chains,
        options : {
            shimDisconnect: false,
        }
    }),
];

const config = createConfig({
    autoConnect: true,
    connectors,
    storage: createStorage({ storage: window.localStorage }),
    publicClient,
})
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <WagmiConfig config={config}>
        <Provider store={store}>
            <App />
        </Provider>,
    </WagmiConfig>
);
reportWebVitals();
